import { SharedService } from './../shared/shared.service';
import { config } from './../config';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AuthenticateService {

  constructor(
    public httpclient: HttpClient,
    public sharedService: SharedService
  ) { }

  isAdminLoggedIn() {
    return true;
  }

  /**
   * API call for login
   * @param data Form data
   */
  login(data) {
    const url = config.login;
    return this.sharedService.postData(url, data);
  }

  loginAPI(data: any) {
    const url = config.loginFastAPI;
    return this.sharedService.postData(url, data);
  }

  loginFastAPI(data: any) {
    const url = config.loginFastAPI;

    const body = new URLSearchParams();
    body.set('email', data.email);
    body.set('password', data.password);
    body.set('version', data.version);

    const headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json'
    };

    return this.httpclient.post(url, body.toString(), {
      headers,
      observe: 'response'
    });
  }


  getUserTypesInCurrentClinic(isAllClinic) {
    const url = `${config.getLoggedUserTypesInCurrentClinic}?isAllClinic=${isAllClinic}`;
    return this.sharedService.getData(url);
  }

  getUserTypesByID(data) {
    const url = `${config.getUserTypesByID}/${data.id}?clinicId=${data.clinicId}&type=${data.type}`;
    return this.sharedService.getData(url);
  }

  refreshLoginTokenAPI() {
    const url = config.refreshlogintokenurl;
    return this.sharedService.getData(url);
  }

  refreshLoginFastTokenAPI(refreshToken: string, companyId: string) {
    const url = config.refreshLoginFastTokenurl;

    const body = {
      refresh_token: refreshToken
    };

    const headers = {
      'Content-Type': 'application/json',
      'accept': 'application/json',
      'x-company-id': companyId
    };

    return this.sharedService.postFastApiData(url, body, { headers });
  }


  /**
   * API call for Forgot password
   * @param email Email
   */
  forgotPassword(email): Observable<any> {
    let forgotPasswordUrl = config.resetPasswordGet;
    forgotPasswordUrl = forgotPasswordUrl.replace(':email', encodeURIComponent(email));
    return this.sharedService.getData(forgotPasswordUrl);
  }

  /**
   * API call to Reset password
   * @param data Form data
   */
  resetPassword(data): Observable<any> {
    const url = config.resetPasswordPut;
    return this.sharedService.putData(url, data);
  }

  /**
   * API call to Activate Email
   * @param data Form data
   */
  activateEmail(data): Observable<any> {
    const url = config.activateUser;
    return this.sharedService.putData(url, data);
  }

  /**
   * API call to Verify Email
   * @param data Form data
   */
  verifyEmail(data): Observable<any> {
    const url = config.verifyEmail;
    return this.sharedService.putData(url, data);
  }

  /**
   * API call to Verify User Email
   * @param data Form data
   */
  verifyUserEmail(data): Observable<any> {
    const url = config.verifyUserEmail;
    return this.sharedService.putData(url, data);
  }

  /**
   * API call to Sign up user
   * @param data Form data
   */
  signup(data): Observable<any> {
    const url = config.signUp;
    return this.sharedService.postData(url, data);
  }

  /**
   * API call to logout user
   */
  logout(): Observable<any> {
    const url = config.logout;
    return this.sharedService.getData(url);
  }

  logoutFastAPI(companyId: string, token: string): Observable<any> {
    const url = config.logoutFastAPI;

    const headers = {
      'x-company-id': companyId,
    };

    return this.sharedService.postFastApiData(url, {}, { headers });
  }


}
